import axios, { AxiosResponse } from "axios";

import { MemberT, MemberPost } from "../hooks/types";

import { sessionToken } from "../constants";

interface GetMemberResponse {
  member: MemberT;
  zendesk: { userId: number; id: number; title: string; body: string }[];
}

export type PutMemberResponse = "solicitação de alteração cadastral está sendo analisada pela equipe Smiles";

export function memberService(apiDomain: string) {
  const smilesMemberUrl = `${apiDomain}/members/v1/members?tickets=true`;
  const token = localStorage.getItem(sessionToken);
  const { CancelToken } = axios;
  const memberServiceSource = CancelToken.source();
  const get = () => {
    return axios
      .get(smilesMemberUrl, {
        cancelToken: memberServiceSource.token,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response: AxiosResponse<GetMemberResponse>) => {
        return response.data;
      })
      .catch((error) => error);
  };

  const put = (member: MemberPost) => {
    return axios
      .put(smilesMemberUrl, member, {
        cancelToken: memberServiceSource.token,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response: AxiosResponse<PutMemberResponse>) => response)
      .catch((error) => error.message);
  };

  return {
    get,
    put,
    memberServiceSource,
  };
}
